import { render, staticRenderFns } from "./testDetail.vue?vue&type=template&id=d391cd8c&scoped=true&"
import script from "./testDetail.vue?vue&type=script&lang=js&"
export * from "./testDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d391cd8c",
  null
  
)

export default component.exports